const checkAgreement = () => localStorage.getItem('cookiesAccepted');
const setAgreement = () => localStorage.setItem('cookiesAccepted', true);

export class CookiesAgreement {
	activeClass = 'cookies-agreement--active';

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	clickHandler = ({ target }) => {
		if (target.closest('.cookies-agreement__close')) {
			this.element.classList.remove(this.activeClass);
			setAgreement();
		}
	};

	init = () => {
		if (!checkAgreement()) {
			this.element.classList.add(this.activeClass);
			this.element.addEventListener('click', this.clickHandler);
		}
	};
}
